export const environment = {
  production: false,
  enableRoleTesting: false,
  showGasForm: true,
  showETSForm: true,
  showGenerationForm: false,
  showRealEstateForm: true,
};
